import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import App from 'containers/App/Loadable';
import "core-js/es/array/includes";
import "core-js/stable";

export default class Root extends Component {
    render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
            <ConnectedRouter history={history}>
              <App/>
            </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
